export const getFacilityStructure = (structureData = [], type, filterType = 'facility', t) => {
  if (type === 'only-facility') {
    return structureData.map((f) => ({ ...f, children: [] }));
  }

  if (filterType === 'groups') {
    return [
      {
        facility_id: null,
        facility_name: null,
        id: 'all',
        name: t('All Groups'),
        level_name: 0,
        treeKey: 'all',
      },
      ...structureData,
    ];
  }

  return structureData && structureData.length > 1
    ? [
        {
          facility_id: null,
          facility_name: null,
          id: 'all',
          name: t('All Facilities'),
          level_name: 0,
        },
        ...structureData,
      ]
    : structureData;
};
